import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import ContentBlocker from "../../components/context/ContentBlocker";
import UploadSchemaWizard from "../../components/schema/upload-schema/UploadSchemaWizard";

class UploadSchemaPage extends React.Component {

  render() {
    return (
      <Row className="UploadSchemaPage">
        <Col>
          <h1>Upload Schema</h1>
          <ContentBlocker checkCreatePermission={true}>
            <UploadSchemaWizard/>
          </ContentBlocker>
        </Col>
      </Row>
    );
  }
}

export default UploadSchemaPage;
